// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion .accordion-content{display:none}.accordion-open .accordion-content{display:block}`, "",{"version":3,"sources":["webpack://./src/components/Accordion/Accordion.scss"],"names":[],"mappings":"AACE,8BACE,YAAA,CAKF,mCACE,aAAA","sourcesContent":[".accordion {\n  .accordion-content {\n    display: none;\n  }\n}\n\n.accordion-open {\n  .accordion-content {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
